import * as configReducer from './config';
import { History } from 'history';
import { combineReducers } from 'redux';

import * as inputReducer from '@wikus-ui/reducers/input';
import * as snackbarReducer from '@wikus-ui/reducers/snackbarEvent';
import {
  Customer,
  CustomerOldStock,
  CustomerStatistics,
  CustomerUser,
  CustomerWithdrawals,
  SnackbarEvent,
  StockArticle,
  TInfo,
  User
} from '../model';

import * as customerArticleReducer from './customer-article';
import * as customerMachineReducer from './customer-machine';
import * as customerOldStockReducer from './customer-old-stock';
import * as customerReducer from './customer';
import * as customerStatisticsReducer from './customer-statistics';
import * as customerUserReducer from './customer-user';
import * as customerWithdrawalsReducer from './customer-withdrawals';
import * as infoReducer from './info';
import * as userReducer from './user';
import { CustomerState } from '../utils/url';
import { Machine, MachineStatisticsWithdrawalsData, MachinesStatisticsWithdrawalsSeries } from '../model/customer-machine';

export interface RootState {
  currentLocale: string;
  snackbarEvents: SnackbarEvent[];
  accessToken: string;
  refreshToken: string;
  user: User;
  users: User[];
  userAdmins: User[];
  customers: Customer[];
  customersCount: number;
  customerUsers: CustomerState<CustomerUser[]>;
  customerArticles: CustomerState<StockArticle[]>;
  customerWithdrawals: CustomerState<CustomerWithdrawals>;
  customerOldStock: CustomerState<CustomerOldStock>;
  customerMachines: CustomerState<Machine[]>;
  customerMachinesStatisticsWithdrawals: CustomerState<MachinesStatisticsWithdrawalsSeries>;
  customerMachineStatisticsWithdrawals: CustomerState<MachineStatisticsWithdrawalsData>;
  customerStatistics: CustomerState<CustomerStatistics>;
  inputGroup: any;
  info: TInfo;
}

export default (history: History) =>
  combineReducers({
    ...configReducer,
    ...snackbarReducer,
    ...userReducer,
    ...inputReducer,
    ...customerReducer,
    ...customerUserReducer,
    ...customerArticleReducer,
    ...customerMachineReducer,
    ...customerStatisticsReducer,
    ...infoReducer,
    ...customerWithdrawalsReducer,
    ...customerOldStockReducer,
  });
